// @flow
import React from 'react';
import {connect} from 'react-redux';
import * as selectors from 'bc/store/selectors';
import {setSelectedEditor} from 'bc/store/actions';
import {isStreamEditable} from 'bc/services/dataStreamService';
import {getEditorValidationMessage} from 'bc/services/googleAuctionsService';
import DimensionsAndMetrics from 'bc/components/streams/editor/common/DimensionsAndMetrics';
import {get} from 'lodash';

type PropTypes = {
  dataStream: Object,
  dimensions: Array<Object>,
  metrics: Array<Object>,
  setSelectedEditor: Function,
};

class GoogleAucDimensionsAndMetrics extends React.PureComponent {
  props: PropTypes;

  setSelectedEditor = function() {
    this.props.setSelectedEditor({
      type: 'dm_auctions',
      editorHeight: 'calc(100% - 210px)',
    });
  };

  render() {
    const {dataStream, dimensions, metrics} = this.props;
    const isEditable = isStreamEditable(dataStream.state) && get(dataStream, 'uiState.analysisResult.fileSchema');

    return (
      <DimensionsAndMetrics
        dataStream={dataStream}
        dimensions={dimensions}
        metrics={metrics}
        isLoading={false}
        isEditable={isEditable}
        validatorFunction={getEditorValidationMessage}
        onSelectEditor={() => this.setSelectedEditor()}
      />
    );
  }
}

export default connect(
  (state) => ({
    dataStream: selectors.getSelectedDataStream(state),
    dimensions: selectors.getAuctionsStreamSelectedDimensions(state),
    metrics: selectors.getAuctionsStreamSelectedMetrics(state),
  }),
  {
    setSelectedEditor,
  },
)(GoogleAucDimensionsAndMetrics);
